import PricingSection from './PricingSection'

export default PricingSection
